<template>
  <div>
      <public-title>
        导游人员列表
      </public-title>
      <div class="bg-white load-area">
        <!--搜索栏-->
        <div class="search-area">
          <div class="w-25 mr-4">
            <left-text-select class="w-100 " leftText="认证状态" :options="$GVAR.authStatusType" v-model="searchCon.storeVerify" :width="90"/>
          </div>
          <select-city class="mb-3 w-45"
              leftText="省市区"
              :width="90"
              :thirdMode="false"
              @getCityInfo="getCityInfo"
              :provinceId="searchCon.province"
              :cityId="searchCon.city"
              />
          <div class="but">
              <el-button type="primary" size="small" @click="searchUser()" icon="el-icon-search">搜索</el-button>
              <el-button  size="small" @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
        <!--表格-->
          <div v-if="list.length>0">
              <el-table
                class="customize-table"
                :data="list"
                ref="tableRef"
                :cell-style="{whiteSpace: 'pre-wrap'}"
              border
              max-height="850"
              style="width: 100%">
              <!--表单内容-->
              <el-table-column v-for="(item,index) in tableData" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center" :sortable="item.sortable" :resizable="false">
                <!-- 自定义表头 -->
                <template slot="header" slot-scope="scope">
                  <span>{{ scope.column.label }}</span>
                  <!-- <p v-if="item.total">{{ AdminDataLists.info.total[item.total] /100 | formatMoney}}</p> -->
                </template>
                <template slot-scope="scope">
                  <!--企业名称-->
                  <div :class="{'text-center':item.center}"  v-if="item.pattern==='title'" @click="$emit('goStoreDetail',scope.row.id)">
                    {{scope.row[item.prop]| formatString(20)}}
                  </div>
                  <!--性别-->
                  <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='sex'">
                    <span class="text-psis" :class="{ 'text-man':scope.row.sex==1,'text-woman':scope.row.sex==2 }">
                          {{ scope.row[item.prop]| formatVar('sex')}}
                    </span>
                  </div>
                  <!--区域-->
                  <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='province'">
                    <span v-if="scope.row[item.prop]">{{scope.row[item.prop] | obtainProvince()}} {{scope.row.city| obtainProvince()}} {{scope.row.district| obtainProvince()}}</span>
                  </div>
                  <!--认证状态-->
                  <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='verify'">
                    <span class="text-psis" :class="{ 'text-cert':scope.row.verify==1 }">
                      {{ scope.row[item.prop]| formatVar('verifyType')}}
                    </span>
                  </div>
                  <!--显示状态-->
                  <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='display'">
                    <span class="text-psis" :class="{ 'text-cert':scope.row.display==1 }">
                      {{ scope.row[item.prop] ?'已显示':'未显示'}}
                    </span>
                  </div>
                  <!--其他-->
                  <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
                </template>
              </el-table-column>
                <!--操作按钮-->
                <el-table-column
                  fixed="right"
                  header-align="center"
                  label="操作"
                  width="150">
                  <template slot-scope="scope">
                    <div class="text-center">
                      <el-button v-if="Math.abs(scope.row.refund_fee)!=scope.row.total_fee" @click="editUser(scope.row)" type="text" size="small" >编辑</el-button>
                    </div>
                  </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <div class="el-pagination">
              <el-pagination background layout="total,prev, pager, next" 
                      :page-size="20"
                      :total="total" :current-page="Number(formData.page)"
                      @current-change="$GFUN.pageChange"/>
            </div>
        </div>
        <div v-else>
            <div class="itemcard">
                <div class="no-search-result">
                <img src="/images/order/icon_22.png"/>
                <div class="no-search-text">
                    <p class="one">抱歉，没有搜索到相关结果。</p>
                    <p class="two">请更改筛选选项后重试</p>
                    <el-button type="primary" @click="resetSearch">清除选项</el-button>
                </div>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'
  export default {
    name: '',
    components: {},
    props: {},
    data() {
      return {
        formData:{
          page:'1',
          storeType:4,
        },
        //搜索条件
        searchCon:{
          storeVerify:'',
          province:'',
          city:'',
          district:[],
        },
          list:[],
          total:0,
          tableData:[ 
            {name:'导游名称',prop:'title',width:300,center:true,pattern:'title'},
            {name:'手机号',prop:'mob',width:200,center:true,},
            {name:'身份证号',prop:'id_card', minWidth:100,center:true,pattern:'id_card'},
            {name:'性别',prop:'sex', minWidth:80,center:true,pattern:'sex'},
            {name:'导游级别',prop:'level', minWidth:80,center:true,pattern:'level'},
            {name:'区域',prop:'province', minWidth:150,center:true,pattern:'province'},
            {name:'认证状态',prop:'verify', minWidth:80,center:true,pattern:'verify'},
            {name:'显示状态',prop:'display', minWidth:80,center:true,pattern:'display'},
        ],
        
      };
    },
    computed: {
       page() { return this.$route.query.page || 1 },
    },
    watch: {
      page:{
        handler(newVal,oldVal){
            this.formData.page = newVal;
            this.getDataLists();
        },
      },
    },
    created() {},
    mounted() {
      this.getDataLists();  
    },
    methods: {
       ...mapActions(['POST_Admin_StoreLists']),
      //获取用户列表
      getDataLists() {
        
        this.POST_Admin_StoreLists({
          data:{
            ...this.formData,
            num:20,
          },
          successFun:(res)=>{
            this.list = res.list;
            this.total = res.count;
            // 获取表格内部滚动容器
            const tableRef = this.$refs.tableRef
            if (!tableRef) return
            const tableWrap = tableRef.bodyWrapper
            if(tableWrap){
              tableWrap.scrollTo({
                top: 0,
                behavior: 'smooth'
              })
            }
          }
        });
      },
      //获取城市信息
      getCityInfo(info) {
        // 只赋值searchCon里面存在的key
        Object.keys(this.searchCon).forEach(key => {
          if (info.hasOwnProperty(key)) {
            this.searchCon[key] = info[key]
          }
        })
        console.log(info)
      },
      //搜索用户
      searchUser() {
        this.formData = { ...this.formData, ...this.searchCon }
        this.handleSearchCommon()
      },
      //重置搜索条件
      resetSearch() {
        this.searchCon = {
          storeVerify:'',
          province:'',
          city:'',
          district:[],
        }
        this.formData = { ...this.formData, ...this.searchCon }
        this.handleSearchCommon()
      },

      /**
       * 搜索/重置公共处理：page重置 + 路由/列表请求
       */
      handleSearchCommon() {
        if (this.formData.page > 1) {
          this.$router.push({
            name: 'SalespersonList',
            query: {
              ...this.$route.query,
              page: 1
            }
          })
        } else {
          this.getDataLists()
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
  .customize-table{
    margin-top: 20px;
  }
  .load-area{
    background-color:inherit !important;
    padding:0 !important;;
  }
  .search-area{                                                                                       
    background-color: #fff;
    text-align:left;
    padding:20px 30px;
    border-radius: 6px;
    display: flex;
  }
  .but{
    margin-left: auto;
  }
  .el-pagination{
    background-color: #fff;
    margin-top:14px;
    padding-bottom:10px;
  }
  .text-psis{
    background-color: #f5f6f9;
    color: #6e7789;
    padding: 6px 8px;
    border-radius: 4px;
    font-size: 12px;
  }
  .text-cert{
    background-color: var(--smtc-color-green);
    color: var(--smtc-color-white);
  }
  .text-woman{
    background-color: var(--smtc-color-text-paleRed);
    color: var(--smtc-color-white);
  }
  .text-sm{
    background-color: var(--smtc-color-text-back);
    color: var(--smtc-color-white) !important;
  }
   .no-search-result{
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 0px 7px #eee;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    padding: 52px 0;
    margin-top: 20px;
    img{
      width: 120px;
    }  
  }
  .no-search-text{
    margin-left: 14px;
    text-align: left;
    .one{
      font-weight: bold;
      font-size: 16px;
    }
    .two{
      color: #666;
      margin: 6px 0;
    }
  }
</style>
